import React, { useEffect, useState } from 'react';
import axios from 'axios';


const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;


const NightOnlyModeModal = ({
  isOpen,
  departmentId,
  nightOnly = false,
  onClose,
  onSaved,
}) => {
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setPassword('');
    setError('');
    setSaving(false);
  }, [isOpen, nightOnly]);

  if (!isOpen) return null;

  const nextNightOnly = !nightOnly;

  const save = async () => {
    if (!password.trim()) {
      setError('Bitte das Admin-Passwort eingeben.');
      return;
    }

    setSaving(true);
    setError('');
    try {
      const response = await axios.post(
        `${API}/daily-night-only/${departmentId}/today/admin-action`,
        {
          night_only: nextNightOnly,
          admin_password: password,
        }
      );
      onSaved?.(response.data);
      onClose?.();
    } catch (err) {
      setError(err.response?.data?.detail || 'Nachtdienst-Modus konnte nicht gespeichert werden.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/55 p-4" onClick={onClose}>
      <div
        className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl"
        onClick={event => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="night-only-mode-title"
      >
        <div className="border-b border-slate-200 px-5 py-4">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 id="night-only-mode-title" className="text-xl font-bold text-slate-900">
                {nextNightOnly ? 'Heute nur Nachtdienst' : 'Normalen Tagesbetrieb wiederherstellen'}
              </h3>
              <p className="mt-1 text-sm text-slate-500">
                {nextNightOnly
                  ? 'Frühstück und Mittagessen werden heute im Bestellformular ausgeblendet. Abendessen bleibt verfügbar.'
                  : 'Frühstück und Mittagessen werden heute wieder im Bestellformular angezeigt.'}
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg p-2 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
              aria-label="Schließen"
            >✕</button>
          </div>
        </div>

        <div className="space-y-3 px-5 py-5">
          <div>
            <label htmlFor="night-only-admin-password" className="mb-1 block text-sm font-medium text-slate-700">
              Admin-Passwort
            </label>
            <input
              id="night-only-admin-password"
              type="password"
              value={password}
              onChange={event => setPassword(event.target.value)}
              onKeyDown={event => { if (event.key === 'Enter') save(); }}
              className="w-full rounded-lg border border-slate-300 px-3 py-2.5 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
              autoComplete="current-password"
              autoFocus
            />
          </div>

          {error && <p className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p>}
        </div>

        <div className="flex gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
          >
            Abbrechen
          </button>
          <button
            type="button"
            data-testid="save-night-only-mode"
            onClick={save}
            disabled={saving}
            className="flex-1 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {saving ? 'Speichern …' : (nextNightOnly ? 'Aktivieren' : 'Deaktivieren')}
          </button>
        </div>
      </div>
    </div>
  );
};


export default NightOnlyModeModal;
